export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const LOADING_USER = "LOADING_USER";
export const SET_USER = "SET_USER";
export const SET_ACCOUNT = "SET_ACCOUNT";

export const SET_PRODUCTS = "SET_PRODUCTS";

export const SET_MY_NFT = "SET_MY_NFT";

export const SET_MY_ORDERS = "SET_MY_ORDERS";
export const SET_WARRANTY_STATUS = "SET_WARRANTY_STATUS";
export const SET_ALL_WARRANTY_REQUESTS = "SET_ALL_WARRANTY_REQUESTS";

export const SET_LOADING = "SET_LOADING"; //NFT Loading

export const SET_AVAIL_STATUS = "SET_AVAIL_STATUS";
export const SET_ALL_AVAIL_REQUESTS = "SET_ALL_AVAIL_REQUESTS";